<template>
  <div>
    <label class="inline-flex items-center">
      <input
        class="form-checkbox mr-2 border-blue-300 text-blue-800"
        type="checkbox"
        :checked="checked"
        @change="$emit('change', { text, number })"
      />
      <span :class="{ 'option-excluded': isExcluded }">
        {{ text }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: false,
      default: -1
    },
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    isExcluded: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.option-excluded {
  color: #a9a9a9;
}
</style>
